module.exports = __webpack_public_path__ + "img/bg_intro_train1.884434f2.svg";